import useWindowSize from '../../hooks/useWindowSize'

interface ResponsiveProps {
  desktopComponent: Function
  mobileComponent: Function
}

const Responsive = (props: ResponsiveProps) => {
  const { width } = useWindowSize()

  return width >= 768 ? props.desktopComponent() : props.mobileComponent()
}

export default Responsive

Responsive.defaultProps = {
  desktopComponent: () => <></>,
  mobileComponent: () => <></>,
}
